import { Factory } from 'rosie';

Factory.define('SearchAggregations');
